import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { LangProvider } from "@/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Approach from "@/pages/Approach";
import Expertise from "@/pages/Expertise";
import Insights from "@/pages/Insights";
import Article from "@/pages/Article";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Presentation from "@/pages/Presentation";
import Questionnaire from "@/pages/Questionnaire";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
    return () => lenis.destroy();
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-sono" element={<About />} />
            <Route path="/approccio" element={<Approach />} />
            <Route path="/aree-competenza" element={<Expertise />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<Article />} />
            <Route path="/risorse" element={<Resources />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/presentazione/:campaignId" element={<Presentation />} />
            <Route path="/q/:token" element={<Questionnaire />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
